import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';

import type { SlackChannelOption } from './types';

type Variables = {
  filter?: 'all' | 'public' | 'private';
};

export const useSlackChannels = createQuery<
  SlackChannelOption[],
  Variables,
  AxiosError
>({
  queryKey: ['internal/partners/organizations/integrations/slack/channels'],
  fetcher: (variables) =>
    client
      .get('v2/internal/partners/organizations/integrations/slack/channels', {
        params: { filter: variables.filter ?? 'all' },
      })
      .then((response) => response.data.data),
});
